export default function components(theme) {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          boxSizing: 'border-box',
        },
        html: {
          height: '100%',
          width: '100%',
        },
        a: {
          textDecoration: 'none',
          color: 'inherit',
        },
        body: {
          height: '100%',
          margin: 0,
          padding: 0,
          fontFamily: theme.typography.fontFamily,
          backgroundColor: theme.palette.background.default,
          color: theme.palette.text.primary,
        },
        '#root': {
          height: '100%',
        },
        '::-webkit-scrollbar': {
          width: '6px',
          height: '6px',
        },
        '::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '::-webkit-scrollbar-thumb': {
          background: theme.palette.mode === 'dark' ? '#333F55' : '#CBD5E1',
          borderRadius: '4px',
        },
        '::-webkit-scrollbar-thumb:hover': {
          background: theme.palette.mode === 'dark' ? '#465670' : '#94A3B8',
        },
        '.border-none': {
          border: '0px',
          td: {
            border: '0px',
          },
        },
        '.btn-xs': {
          minWidth: '30px !important',
          width: '30px',
          height: '30px',
          borderRadius: '6px !important',
          padding: '0px !important',
        },
        '.hover-text-primary:hover .text-hover': {
          color: theme.palette.primary.main,
        },
        '.hoverCard': {
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        },
        '.hoverCard:hover': {
          transform: 'translateY(-3px)',
          boxShadow: theme.shadows[4],
        },
        '.MuiCardHeader-action': {
          alignSelf: 'center !important',
        },
        '.scrollbar-container': {
          borderRight: '0 !important',
        },
        '.simplebar-scrollbar:before': {
          background: `${theme.palette.grey[300]} !important`,
        },
      },
    },
    MuiButtonGroup: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          borderRadius: '8px',
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          ':before': {
            backgroundColor: theme.palette.divider,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          borderRadius: '12px',
        },
        outlined: {
          borderColor: theme.palette.divider,
        },
        elevation1: {
          boxShadow: theme.shadows[1],
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          boxShadow: 'none',
          borderRadius: '8px',
          fontWeight: 600,
          fontSize: '0.8125rem',
          padding: '6px 16px',
          minHeight: '34px',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            boxShadow: theme.shadows[2],
          },
        },
        sizeSmall: {
          padding: '4px 10px',
          fontSize: '0.75rem',
          borderRadius: '6px',
          minHeight: '28px',
        },
        sizeMedium: {
          padding: '6px 16px',
          fontSize: '0.8125rem',
          borderRadius: '8px',
          minHeight: '34px',
        },
        sizeLarge: {
          padding: '8px 20px',
          fontSize: '0.875rem',
          borderRadius: '8px',
          minHeight: '38px',
        },
        containedPrimary: {
          backgroundColor: theme.palette.primary.main,
          color: '#ffffff',
          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
          },
        },
        containedSecondary: {
          backgroundColor: theme.palette.secondary.main,
          color: '#ffffff',
          '&:hover': {
            backgroundColor: theme.palette.secondary.dark,
          },
        },
        outlinedPrimary: {
          borderColor: theme.palette.primary.main,
          color: theme.palette.primary.main,
          '&:hover': {
            borderColor: theme.palette.primary.dark,
            backgroundColor: theme.palette.primary.light,
          },
        },
        textPrimary: {
          color: theme.palette.primary.main,
          '&:hover': {
            backgroundColor: theme.palette.primary.light,
          },
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          padding: '18px 24px 12px',
        },
        title: {
          fontSize: '1.125rem',
          fontWeight: 600,
        },
        subheader: {
          fontSize: '0.8125rem',
          color: theme.palette.text.secondary,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          width: '100%',
          borderRadius: '12px',
          backgroundImage: 'none',
          boxShadow: theme.shadows[2],
          border: `1px solid ${theme.palette.divider}`,
          transition: 'box-shadow 0.2s ease, transform 0.2s ease',
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '20px 24px',
          '&:last-child': {
            paddingBottom: '24px',
          },
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          width: '100%',
          overflowX: 'auto',
          WebkitOverflowScrolling: 'touch',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-root': {
            backgroundColor:
              theme.palette.mode === 'dark' ? theme.palette.grey[100] : '#fbf9f6',
            color: theme.palette.text.secondary,
            fontWeight: 600,
            fontSize: '0.8125rem',
            letterSpacing: '0.02em',
            borderBottom: `1px solid ${theme.palette.divider}`,
            padding: '12px 16px',
            whiteSpace: 'nowrap',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${theme.palette.divider}`,
          padding: '12px 16px',
          fontSize: '0.875rem',
          fontWeight: 500,
          color: theme.palette.text.primary,
          whiteSpace: 'nowrap',
          fontFamily: theme.typography.fontFamily,
          lineHeight: 1.5,
          '& .MuiTypography-root': {
            fontSize: '0.875rem !important',
            fontWeight: '500 !important',
            color: 'inherit',
            whiteSpace: 'nowrap',
            lineHeight: 1.5,
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          transition: 'background-color 0.15s ease',
          '&:hover': {
            backgroundColor:
              theme.palette.mode === 'dark'
                ? 'rgba(255, 255, 255, 0.03)'
                : 'rgba(180, 138, 98, 0.04)',
          },
          '&:last-child td': {
            borderBottom: 0,
          },
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          borderTop: `1px solid ${theme.palette.divider}`,
          color: theme.palette.text.secondary,
        },
        select: {
          paddingLeft: '8px',
          paddingRight: '24px',
        },
        actions: {
          marginLeft: '16px',
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: '44px',
        },
        indicator: {
          backgroundColor: theme.palette.primary.main,
          height: '3px',
          borderRadius: '3px 3px 0 0',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '0.875rem',
          minHeight: '44px',
          padding: '8px 16px',
          color: theme.palette.text.secondary,
          '&.Mui-selected': {
            color: theme.palette.primary.main,
          },
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.grey[200],
          borderRadius: '6px',
          height: '6px',
        },
        bar: {
          borderRadius: '6px',
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: theme.palette.divider,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          fontSize: '0.75rem',
          borderRadius: '6px',
        },
        sizeSmall: {
          height: '24px',
        },
        colorPrimary: {
          backgroundColor: theme.palette.primary.light,
          color: theme.palette.primary.main,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: '10px',
        },
        filledSuccess: {
          color: 'white',
        },
        filledInfo: {
          color: 'white',
        },
        filledError: {
          color: 'white',
        },
        filledWarning: {
          color: 'white',
        },
        standardSuccess: {
          backgroundColor: theme.palette.success.light,
          color: theme.palette.success.main,
        },
        standardError: {
          backgroundColor: theme.palette.error.light,
          color: theme.palette.error.main,
        },
        standardWarning: {
          backgroundColor: theme.palette.warning.light,
          color: theme.palette.warning.main,
        },
        standardInfo: {
          backgroundColor: theme.palette.info.light,
          color: theme.palette.info.main,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.divider,
            transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main,
            borderWidth: '1.5px',
          },
        },
        input: {
          padding: '11px 14px',
          fontSize: '0.875rem',
        },
        inputSizeSmall: {
          padding: '8px 12px',
          fontSize: '0.8125rem',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '0.875rem',
          '&.Mui-focused': {
            color: theme.palette.primary.main,
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          borderRadius: '6px',
          fontSize: '0.75rem',
          padding: '6px 10px',
          color: theme.palette.background.paper,
          background: theme.palette.text.primary,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderColor: theme.palette.divider,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '14px',
          boxShadow: theme.shadows[8],
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: '1.2rem',
          fontWeight: 600,
          padding: '20px 24px 12px',
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: '16px 24px 20px',
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '12px 24px 20px',
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          borderRadius: '10px',
          boxShadow: theme.shadows[6],
          border: `1px solid ${theme.palette.divider}`,
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          borderRadius: '6px',
          fontWeight: 600,
          '&.Mui-selected': {
            backgroundColor: theme.palette.primary.main,
            color: '#ffffff',
            '&:hover': {
              backgroundColor: theme.palette.primary.dark,
            },
          },
        },
      },
    },
  };
}
